import React, { useState, useMemo } from 'react';
import P2pLayout from './P2pLayout';
import './p2p.css';

const MOCK_ORDERS = [
  {
    id: '1',
    side: 'Buy',
    asset: 'USDT',
    date: '2026-08-04 16:16',
    orderNumber: '22917908376209371136',
    price: '26,981 VND',
    fiatAmount: '150,000 VND',
    cryptoAmount: '5.48 USDT',
    counterparty: 'TuanleAK',
    status: 'Cancelled',
    hasAppeal: true
  },
  {
    id: '2',
    side: 'Buy',
    asset: 'USDT',
    date: '2026-07-31 18:22',
    orderNumber: '22916490399642349568',
    price: '1.001 USD',
    fiatAmount: '500 USD',
    cryptoAmount: '499.42 USDT',
    counterparty: 'Green_EXC',
    status: 'Cancelled',
    hasAppeal: true
  },
  {
    id: '3',
    side: 'Buy',
    asset: 'USDT',
    date: '2026-08-04 16:16',
    orderNumber: '22917908376209371136',
    price: '26,981 VND',
    fiatAmount: '150,000 VND',
    cryptoAmount: '5.48 USDT',
    counterparty: 'TuanleAK',
    status: 'Cancelled',
    hasAppeal: true
  },
  {
    id: '4',
    side: 'Buy',
    asset: 'USDT',
    date: '2026-07-31 18:22',
    orderNumber: '22916490399642349568',
    price: '1.001 USD',
    fiatAmount: '500 USD',
    cryptoAmount: '499.42 USDT',
    counterparty: 'Green_EXC',
    status: 'Cancelled',
    hasAppeal: true
  },
  {
    id: '5',
    side: 'Buy',
    asset: 'USDT',
    date: '2026-07-28 14:10',
    orderNumber: '22915839201948572019',
    price: '1.000 USD',
    fiatAmount: '1,000 USD',
    cryptoAmount: '1,000.00 USDT',
    counterparty: 'FastTrader_AE',
    status: 'Completed',
    hasAppeal: false
  },
  {
    id: '6',
    side: 'Sell',
    asset: 'USDT',
    date: '2026-07-25 11:30',
    orderNumber: '22914728194827163821',
    price: '26,990 VND',
    fiatAmount: '2,700,000 VND',
    cryptoAmount: '100.04 USDT',
    counterparty: 'CryptoVN_Pro',
    status: 'Completed',
    hasAppeal: false
  },
  {
    id: '7',
    side: 'Buy',
    asset: 'BTC',
    date: '2026-07-22 09:15',
    orderNumber: '22913619284719284712',
    price: '64,250 USD',
    fiatAmount: '3,212.50 USD',
    cryptoAmount: '0.05 BTC',
    counterparty: 'GulfCrypto',
    status: 'Appeal',
    hasAppeal: true
  },
  {
    id: '8',
    side: 'Buy',
    asset: 'USDT',
    date: '2026-08-04 17:05',
    orderNumber: '22918294829104829102',
    price: '100.85 INR',
    fiatAmount: '10,000 INR',
    cryptoAmount: '99.15 USDT',
    counterparty: 'Trunks097',
    status: 'Processing',
    hasAppeal: false
  }
];

const P2pOrders = () => {
  const [activeMainTab, setActiveMainTab] = useState('All Orders'); // Processing | All Orders | Profit & Loss Statement
  const [activeStatusFilter, setActiveStatusFilter] = useState('All'); // All | Completed | Canceled | Appeal
  const [searchQuery, setSearchQuery] = useState('');
  const [copiedId, setCopiedId] = useState(null);

  // Filter dropdown states
  const [selectedCoin, setSelectedCoin] = useState('All coins');
  const [selectedCurrency, setSelectedCurrency] = useState('All');
  const [selectedOrderType, setSelectedOrderType] = useState('All');
  const dateRangeText = '2026-02-04 → 2026-08-04';

  // Copy helper
  const handleCopyOrderNumber = (orderNum) => {
    navigator.clipboard?.writeText(orderNum);
    setCopiedId(orderNum);
    setTimeout(() => setCopiedId(null), 2000);
  };

  // Reset filters
  const handleResetFilters = () => {
    setActiveStatusFilter('All');
    setSelectedCoin('All coins');
    setSelectedCurrency('All');
    setSelectedOrderType('All');
    setSearchQuery('');
  };

  // Filtered orders logic
  const filteredOrders = useMemo(() => {
    return MOCK_ORDERS.filter((order) => {
      // Main tab filter
      if (activeMainTab === 'Processing' && order.status !== 'Processing') {
        return false;
      }

      // Sub-status filter
      if (activeStatusFilter === 'Completed' && order.status !== 'Completed') {
        return false;
      }
      if (activeStatusFilter === 'Canceled' && order.status !== 'Cancelled') {
        return false;
      }
      if (activeStatusFilter === 'Appeal' && order.status !== 'Appeal' && !order.hasAppeal) {
        return false;
      }

      // Coin filter
      if (selectedCoin !== 'All coins' && order.asset !== selectedCoin) {
        return false;
      }

      // Order type filter
      if (selectedOrderType === 'Buy' && order.side !== 'Buy') return false;
      if (selectedOrderType === 'Sell' && order.side !== 'Sell') return false;

      // Search query
      if (searchQuery.trim()) {
        const query = searchQuery.toLowerCase().trim();
        const matchesOrder = order.orderNumber.toLowerCase().includes(query);
        const matchesUser = order.counterparty.toLowerCase().includes(query);
        const matchesAsset = order.asset.toLowerCase().includes(query);
        if (!matchesOrder && !matchesUser && !matchesAsset) return false;
      }

      return true;
    });
  }, [activeMainTab, activeStatusFilter, selectedCoin, selectedOrderType, searchQuery]);

  return (
    <P2pLayout title="My Orders">
      <div className="p2p-my-orders-container">
        
        {/* ==================== 1. PAGE HEADER ==================== */}
        <div className="p2p-my-orders-header">
          <h2>My Orders</h2>
          <p>Manage and track all your P2P orders in one place</p>
        </div>

        {/* ==================== 2. TOP NAVIGATION TABS ==================== */}
        <div className="p2p-mo-top-nav">
          {['Processing', 'All Orders', 'Profit & Loss Statement'].map((tab) => (
            <button
              key={tab}
              type="button"
              className={`p2p-mo-top-tab ${activeMainTab === tab ? 'active' : ''}`}
              onClick={() => setActiveMainTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* ==================== 3. SUB-FILTER PILLS & ACTIONS ==================== */}
        <div className="p2p-mo-subnav-row">
          <div className="p2p-mo-pill-group">
            {['All', 'Completed', 'Canceled', 'Appeal'].map((pill) => (
              <button
                key={pill}
                type="button"
                className={`p2p-mo-pill-btn ${activeStatusFilter === pill ? 'active' : ''}`}
                onClick={() => setActiveStatusFilter(pill)}
              >
                {pill}
              </button>
            ))}
          </div>

          <div className="p2p-mo-action-icons">
            <button type="button" className="p2p-mo-icon-btn" title="Filter options">
              <i className="ri-filter-3-line"></i>
            </button>
            <button type="button" className="p2p-mo-icon-btn" title="Export statement">
              <i className="ri-upload-2-line"></i>
            </button>
            <button type="button" className="p2p-mo-icon-btn" title="Toggle view">
              <i className="ri-layout-grid-line"></i>
            </button>
            <button type="button" className="p2p-mo-icon-btn" title="Grid display">
              <i className="ri-apps-line"></i>
            </button>
          </div>
        </div>

        {/* ==================== 4. SUMMARY STATS CARDS ==================== */}
        <div className="p2p-mo-stats-grid">
          {/* Card 1: Total Orders */}
          <div className="p2p-mo-stat-card">
            <div className="p2p-mo-stat-info">
              <div className="p2p-mo-stat-header">
                <span className="p2p-mo-dot blue"></span>
                <span>Total Orders</span>
              </div>
              <div className="p2p-mo-stat-val">128</div>
            </div>
            <div className="p2p-mo-stat-badge yellow">
              <i className="ri-file-text-line"></i>
            </div>
          </div>

          {/* Card 2: Completed */}
          <div className="p2p-mo-stat-card">
            <div className="p2p-mo-stat-info">
              <div className="p2p-mo-stat-header">
                <span className="p2p-mo-dot green"></span>
                <span>Completed</span>
              </div>
              <div className="p2p-mo-stat-val">96</div>
            </div>
            <div className="p2p-mo-stat-badge green">
              <i className="ri-checkbox-circle-line"></i>
            </div>
          </div>

          {/* Card 3: Cancelled */}
          <div className="p2p-mo-stat-card">
            <div className="p2p-mo-stat-info">
              <div className="p2p-mo-stat-header">
                <span className="p2p-mo-dot red"></span>
                <span>Cancelled</span>
              </div>
              <div className="p2p-mo-stat-val">24</div>
            </div>
            <div className="p2p-mo-stat-badge red">
              <i className="ri-close-circle-line"></i>
            </div>
          </div>

          {/* Card 4: Appeals */}
          <div className="p2p-mo-stat-card">
            <div className="p2p-mo-stat-info">
              <div className="p2p-mo-stat-header">
                <span className="p2p-mo-dot purple"></span>
                <span>Appeals</span>
              </div>
              <div className="p2p-mo-stat-val">8</div>
            </div>
            <div className="p2p-mo-stat-badge purple">
              <i className="ri-scales-3-line"></i>
            </div>
          </div>
        </div>

        {/* ==================== 5. SECOND FILTER ROW ==================== */}
        <div className="p2p-mo-filter-bar">
          <div className="p2p-mo-filter-left">
            {/* Coins */}
            <div className="p2p-mo-select-wrap">
              <label>Coins</label>
              <select 
                value={selectedCoin} 
                onChange={(e) => setSelectedCoin(e.target.value)}
                className="p2p-mo-native-select"
              >
                <option value="All coins">All coins</option>
                <option value="USDT">USDT</option>
                <option value="BTC">BTC</option>
                <option value="ETH">ETH</option>
              </select>
              <i className="ri-arrow-down-s-line"></i>
            </div>

            {/* Currency */}
            <div className="p2p-mo-select-wrap">
              <label>Currency</label>
              <select 
                value={selectedCurrency} 
                onChange={(e) => setSelectedCurrency(e.target.value)}
                className="p2p-mo-native-select"
              >
                <option value="All">All</option>
                <option value="VND">VND</option>
                <option value="USD">USD</option>
                <option value="INR">INR</option>
                <option value="AED">AED</option>
              </select>
              <i className="ri-arrow-down-s-line"></i>
            </div>

            {/* Order Type */}
            <div className="p2p-mo-select-wrap">
              <label>Order Type</label>
              <select 
                value={selectedOrderType} 
                onChange={(e) => setSelectedOrderType(e.target.value)}
                className="p2p-mo-native-select"
              >
                <option value="All">All</option>
                <option value="Buy">Buy</option>
                <option value="Sell">Sell</option>
              </select>
              <i className="ri-arrow-down-s-line"></i>
            </div>

            {/* Date Range Picker */}
            <div className="p2p-mo-date-wrap">
              <span>{dateRangeText}</span>
              <i className="ri-calendar-line"></i>
            </div>
          </div>

          <div className="p2p-mo-filter-right">
            {/* Search Input */}
            <div className="p2p-mo-search-box">
              <i className="ri-search-line"></i>
              <input
                type="text"
                placeholder="Search order no."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            {/* Reset Button */}
            <button
              type="button"
              className="p2p-mo-reset-btn"
              onClick={handleResetFilters}
            >
              Reset
            </button>
          </div>
        </div>

        {/* ==================== 6. ORDERS TABLE ==================== */}
        <div className="p2p-mo-table-card">
          <div className="p2p-mo-table-responsive">
            <table className="p2p-mo-table">
              <thead>
                <tr>
                  <th>Type / Date</th>
                  <th>Order Number</th>
                  <th>Price</th>
                  <th>Fiat / Crypto Amount</th>
                  <th>Counterparty</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredOrders.length > 0 ? (
                  filteredOrders.map((order) => (
                    <tr key={order.id}>
                      {/* 1. Type / Date */}
                      <td>
                        <div className="p2p-mo-type-cell">
                          <div className="p2p-mo-type-line">
                            <span className={`p2p-mo-side ${order.side.toLowerCase()}`}>
                              {order.side}
                            </span>
                            <span className="p2p-mo-asset">{order.asset}</span>
                          </div>
                          <div className="p2p-mo-date-line">
                            <i className="ri-calendar-line"></i>
                            <span>{order.date}</span>
                          </div>
                        </div>
                      </td>

                      {/* 2. Order Number */}
                      <td>
                        <div className="p2p-mo-order-id-cell">
                          <span className="p2p-mo-order-num">{order.orderNumber}</span>
                          <button
                            type="button"
                            className="p2p-mo-copy-btn"
                            title="Copy Order ID"
                            onClick={() => handleCopyOrderNumber(order.orderNumber)}
                          >
                            <i className={copiedId === order.orderNumber ? "ri-check-line" : "ri-file-copy-line"}></i>
                          </button>
                        </div>
                      </td>

                      {/* 3. Price */}
                      <td>
                        <span className="p2p-mo-price-val">{order.price}</span>
                      </td>

                      {/* 4. Fiat / Crypto Amount */}
                      <td>
                        <div className="p2p-mo-amount-cell">
                          <strong className="p2p-mo-fiat-val">{order.fiatAmount}</strong>
                          <span className="p2p-mo-crypto-val">{order.cryptoAmount}</span>
                        </div>
                      </td>

                      {/* 5. Counterparty */}
                      <td>
                        <div className="p2p-mo-counterparty-cell">
                          <span className="p2p-mo-user-name">{order.counterparty}</span>
                          <button type="button" className="p2p-mo-chat-pill">
                            Chat
                          </button>
                        </div>
                      </td>

                      {/* 6. Status */}
                      <td>
                        <div className="p2p-mo-status-cell">
                          <span className={`p2p-mo-status-badge ${order.status.toLowerCase()}`}>
                            {order.status}
                          </span>
                          {order.hasAppeal && (
                            <span className="p2p-mo-appeal-link">
                              Appeal &gt;
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="p2p-mo-empty-row">
                      <div className="p2p-mo-empty-content">
                        <i className="ri-file-list-line"></i>
                        <p>No orders found matching the selected filters.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </P2pLayout>
  );
};

export default P2pOrders;
